import React from 'react';

const PRESETS = [
  { label: '7D',  days: 7  },
  { label: '14D', days: 14 },
  { label: '30D', days: 30 },
  { label: '90D', days: 90 },
];

function fmtDate(d) { return d.toISOString().split('T')[0]; }

export default function Header({ title, startDate, endDate, onDateChange, onRefresh, loading, theme, onToggleTheme, onMenuClick }) {
  const isDark = theme === 'dark';

  const handlePreset = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days);
    onDateChange(fmtDate(start), fmtDate(end));
  };

  return (
    <header style={styles.header}>
      <div style={styles.titleWrap}>
        <button
          className="sidebar-toggle-btn"
          style={styles.menuBtn}
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <i className="bx bx-menu" style={styles.menuIcon} />
        </button>
        <div>
          <h1 style={styles.title}>{title}</h1>
          <p style={styles.sub}>{startDate} → {endDate}</p>
        </div>
      </div>

      <div style={styles.controls}>
        {/* Preset Buttons */}
        <div style={styles.presets}>
          {PRESETS.map(p => (
            <button key={p.label} style={styles.preset} onClick={() => handlePreset(p.days)}>
              {p.label}
            </button>
          ))}
        </div>

        {/* Date Pickers */}
        <div style={styles.dateRow}>
          <input
            type="date" value={startDate} max={endDate}
            onChange={e => onDateChange(e.target.value, endDate)}
            style={styles.dateInput}
          />
          <span style={styles.dateSep}>→</span>
          <input
            type="date" value={endDate} min={startDate}
            onChange={e => onDateChange(startDate, e.target.value)}
            style={styles.dateInput}
          />
        </div>

        {/* Theme toggle */}
        <button style={styles.themeBtn} onClick={onToggleTheme} title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
          <i className={`bx ${isDark ? 'bx-sun' : 'bx-moon'}`} style={{ fontSize: 14 }} />
          <span style={styles.themeBtnLabel}>{isDark ? 'Light' : 'Dark'}</span>
        </button>

        {/* Refresh */}
        <button style={{ ...styles.refreshBtn, opacity: loading ? 0.7 : 1 }} onClick={onRefresh} disabled={loading}>
          <i
            className="bx bx-refresh"
            style={{ fontSize: 14, animation: loading ? 'spin 0.8s linear infinite' : 'none' }}
          />
          {' '}Refresh
        </button>
      </div>
    </header>
  );
}

const styles = {
  header: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    flexWrap: 'wrap', gap: 14, padding: '14px 24px',
    borderBottom: '1px solid var(--border)',
    background: 'var(--header-bg)',
    position: 'sticky', top: 0, zIndex: 50,
    transition: 'background 0.25s, border-color 0.25s',
    boxShadow: 'var(--shadow-sm)',
  },
  titleWrap: { display: 'flex', alignItems: 'center', gap: 12 },
  menuBtn: {
    display: 'none', alignItems: 'center', justifyContent: 'center',
    width: 38, height: 38, borderRadius: 9,
    background: 'var(--surface2)', border: '1px solid var(--border)',
    color: 'var(--text)', cursor: 'pointer', padding: 0,
  },
  menuIcon: { fontSize: 22, lineHeight: 1, color: 'var(--text)' },
  title: { fontSize: 19, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.4px' },
  sub:   { fontSize: 11, color: 'var(--text3)', marginTop: 2, fontFamily: 'Space Mono, monospace' },
  controls: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
  presets: { display: 'flex', gap: 4 },
  preset: {
    padding: '6px 10px', background: 'var(--surface2)',
    border: '1px solid var(--border)', borderRadius: 7,
    color: 'var(--text2)', fontSize: 11, fontWeight: 600,
    letterSpacing: '0.04em', transition: 'all 0.15s', cursor: 'pointer',
  },
  dateRow: { display: 'flex', alignItems: 'center', gap: 7 },
  dateSep: { color: 'var(--text3)', fontSize: 12 },
  dateInput: {
    background: 'var(--surface2)', border: '1px solid var(--border)',
    borderRadius: 8, color: 'var(--text)', padding: '7px 10px',
    fontSize: 12, outline: 'none', width: 138,
    transition: 'background 0.2s',
  },
  themeBtn: {
    display: 'flex', alignItems: 'center', gap: 5,
    padding: '7px 12px', background: 'var(--surface2)',
    border: '1px solid var(--border)', borderRadius: 8,
    color: 'var(--text2)', fontSize: 12, fontWeight: 500,
    cursor: 'pointer', transition: 'all 0.15s',
  },
  themeBtnLabel: { fontSize: 12 },
  refreshBtn: {
    padding: '8px 15px', background: 'var(--accent)',
    border: 'none', borderRadius: 8,
    color: '#fff', fontWeight: 700, fontSize: 12,
    letterSpacing: '0.02em', transition: 'all 0.15s', cursor: 'pointer',
  },
};
